import { ValueOf } from '@@types/common';

export { default as MODAL_NAMES } from './modalNames';

export const LOCALE_CODE = {
  KO_KR: 'ko_KR',
  EN_US: 'en_US',
  JA_JP: 'ja_JP',
  ZH_CN: 'zh_CN',
} as const;
export type LOCALE_CODE = ValueOf<typeof LOCALE_CODE>;

export const LANGUAGES = [
  { label: '한국어', value: LOCALE_CODE.KO_KR },
  { label: 'English', value: LOCALE_CODE.EN_US },
  { label: '日本語', value: LOCALE_CODE.JA_JP },
  { label: '简体中文', value: LOCALE_CODE.ZH_CN },
];

export const LOCALE = {
  KO: 'ko',
  EN: 'en',
  JA: 'ja',
  ZH: 'zh',
  ZH_CN: 'zh-CN',
  ZH_TW: 'zh-TW',
} as const;
export type LOCALE = ValueOf<typeof LOCALE>;

export const URLS = {
  BASE: '/messenger/assets/src/app',
  API: '/messenger/v1/api',
  V2_API: '/messenger/v2/api',
  V4_API: '/messenger/v4',
  WAS_API: '/v2/wapi',
  MOBILE_API: '/v2/mapi',
  ACCOUNT_API: '/wapi/account/v1',
  PROJECT_API: '/messenger/membership/api',
  PROJECT_TASK: '/project/tasks/',
  INNER_API: '/messenger/inner/api',
  SIGN_OUT_MESSENGER: '/messenger/logout',
  SIGN_OUT: '/auth/signout?nextUrl=/messenger/logout',
  INQUIRE_NHN_POPUP: '/task/write/new?projectId=1387695783393701376', // (문의-요청-Req)Dooray
  ORG_CHART: '/address-book?service=messenger',
  TASK_WRITE: '/task/write/new',
  TASK_DRAFT_WRITE: '/task/write/draft/',
  TASK_VIEW: '/task/view/tasks/',
  CALENDAR_WRITE: '/calendar/write/new',
  INQUIRE_MAIL: 'mailto:help@dooray.com',
  DEFAULT_BOT_IMAGE: '/static_images/icon/ic_bot_default.png',
  DEFAULT_PROFILE_IMAGE: '/static_images/profile.png',
  EMOJIS: '/static_images/emoji/',
  SIDE_APP_API: '/sideapp/v2',
  BILLING_API: '/wapi/billing/v1',
} as const;
export type URLS = typeof URLS[keyof typeof URLS];

export const LOG_TYPE = {
  INVITE_MEMBER: -1,
  TEXT: 0,
  SYSTEM: 1,
  WEBHOOK: 2,
  // BOT: 3,
  FILE: 4,
  STICKER: 5,
  COMMAND: 6,
  VOIP: 7,
  MAIL: 8,
  FORWARD: 9,
  REPLY: 10,
} as const;
export type LOG_TYPE = ValueOf<typeof LOG_TYPE>;

export const LOG_FLAGS = {
  NORMAL: 0,
  DELETED: 1,
  EDIT: 2,
  THREAD_LOG_DELETED: 3,
} as const;
export type LOG_FLAGS = ValueOf<typeof LOG_FLAGS>;

export enum ChannelType {
  Direct = 'direct',
  Private = 'private',
  Bot = 'bot',
  ALL = 'ALL',
  Me = 'me',
  Thread = 'thread',
  Custom = 'custom',
}

export enum SYSTEM_LOG_TYPE {
  ADD_COMMAND = 'addCommand',
  REMOVE_COMMAND = 'removeCommand',
  JOIN_MEMBER = 'joinMember',
  CREATE_CHANNEL = 'createChannel',
  LEAVE_MEMBER = 'leaveMember',
  ARCHIVE_CHANNEL = 'archiveChannel',
  CHANGE_TITLE = 'changeChannelTitle',
  REMOVE_MEMBER = 'removeMember',
  TRANSLATION = 'translate',
  CHANGE_TRANSLATE_OPTION = 'translate',
  CHANGE_CHANNEL_IMAGE = 'changeChannelImage',
  TURN_ADMIN_ON = 'turnAdminOn',
  TURN_ADMIN_OFF = 'turnAdminOff',
  ADD_ADMIN = 'addAdmin',
  DELETE_ADMIN = 'deleteAdmin',
  UNARCHIVE_CHANNEL = 'unarchiveChannel',
  ARCHIVE_EMPTY_CHANNEL = 'archiveEmptyChannel',
  CREATE_TASK = 'createTask',
  DETACH_TASK = 'detachTask',
  DELETE_TASK = 'deleteTask',
  SUGGEST_EXPORT_TASK = 'suggestExportingToTask',
}

export const SYNTAX_REGEX = {
  escapedDoorayLink: /\[([^[]*?)\]\(dooray:\/\/(\d+)\/(\w+)\/(\d+) &quot;(\w+)&quot;\)/g,
  doorayLink: /\[([^[]*?)\]\(dooray:\/\/(\d+)\/(\w+)\/(\d+) "(\w+)"\)/,
  doorayLinkFromMarkdown: /<a href="dooray:\/\/(\d+)?\/([\w-]+)\/(\d+)?"(?:\stitle="([a-z]+)")?[^>]*>(.*?)<\/a>/g,
  doorayEmojiFromTag: /!\[dooray-icon-(:[a-z0-9\-_+]+:)\]\(.*?\)/g,
  mention: /\[@(.*?)\]\(dooray:\/\/(\d+?)\/members\/(\d+?)( "[a-z]+?")?\)/g,
  taskWithCode:
    /(^[a-zA-Z0-9@()\-.~\u3131-\u314E\u314F-\u3163\uAC00-\uD7A3\u3040-\u309F\u30A0-\u30FF\u3400-\u4DB5\u4E00-\u9FCC]+)\/([0-9]+)/,
  taskWithCodeAndSubject:
    /(^[a-zA-Z0-9@()\-.~\u3131-\u314E\u314F-\u3163\uAC00-\uD7A3\u3040-\u309F\u30A0-\u30FF\u3400-\u4DB5\u4E00-\u9FCC]+)\/(.*)/, // Dooray-서비스/256. Dooray-서비스/공통 APi개발
  task: /([a-zA-Z0-9@()\-.~\u3131-\u314E\u314F-\u3163\uAC00-\uD7A3\u3040-\u309F\u30A0-\u30FF\u3400-\u4DB5\u4E00-\u9FCC]+)\/([0-9]+)(?:\s(.*))?/, // bug/256 제목제목
  taskHyperlinkUrl:
    /<a href="http:\/\/[a-z0-9\-_.]+dooray.com(?::[0-9]+)?(?:\/[a-zA-Z0-9ㄱ-ㅎㅏ-ㅣ가-힣-_.]+)*\/([a-z0-9\-_.@]+)\/(\d+)\W?[a-z0-9\-_=&;@">\s:/.,?]+<\/a>/gi,
  htmlTag: /<[^>]*>/g,
  htmlElementStream: /(<style>[^<]*<\/style>|<[^>]*>|&nbsp;|(\s)+)+/g,
  stringWithoutHtmlTag: /([^<]+)/g,
  icon: /([^-])?:([a-z0-9\-_+]+):/g,
  image: /!\[(.*?)\]\((data:.*?)\)/g,
  regex: /^\/(.*)\/[gi]*?$/g,
  markdownLink:
    /\[(.*?)\]\(((?:http|ftp|https|zpl):\/\/[\w\S-]+(?:\.[\w\S-]+)*([\w\S.,@?^=%&amp;:/~+#-]*[\w@?^=%&amp;/~+#-])?)\)/gi,
  plainLink: /(?:http|ftp|https|zpl):\/\/[\w\S-]+(?:\.[\w\S-]+)*([\w\S.,@?^=%&amp;:\/~+#-]*[\w@?^=%&amp;\/~+#-])?/gi,
  number: /^\d+$/,
  tel: /^\d+[-\s.]?\d+[-\s.]?\d+$/, // 전화번호
  url: /^((https?|ftp|mailto|tel|file|dooray)?(:\/\/))?(www\.)?[a-zA-Z0-9-_\.]+(\.[a-zA-Z0-9]+)([-a-zA-Z0-9:%_\+.~#?&\/=]*)$/,
  email:
    /^[A-Za-z0-9!#$%&'*+\/=?^_`{|}~-]+(?:\.[A-Za-z0-9!#$%&'*+\/=?^_`{|}~-]+)*@(?:[A-Za-z\d_](?:[A-Za-z\d_\-]*[A-Za-z\d_])?\.)+[A-Za-z\d_](?:[A-Za-z\d_\-]*[A-Za-z\d_])?$/,
  meetingUrl: /^(https?:\/\/)?meeting(\.[^.\/]+)?\.dooray\.com\//,
};

export enum MemberStatus {
  Offline = 'OFFLINE',
  AutoActive = 'AUTO_ACTIVE',
  Active = 'ACTIVE',
  Away = 'AWAY',
  AutoAway = 'AUTO_AWAY',
  Busy = 'BUSY',
}

export const TIMEZONES = [
  { label: 'GMT-11:00 (MidwayIsland, Samoa)', value: 'US/Samoa' },
  { label: 'GMT-10:00 (Hawaii)', value: 'US/Hawaii' },
  { label: 'GMT-09:30 (Marquesas)', value: 'Pacific/Marquesas' },
  { label: 'GMT-09:00 (Alaska)', value: 'US/Alaska' },
  { label: 'GMT-08:00 (PacificTime)', value: 'Canada/Pacific' },
  { label: 'GMT-07:00 (MountainTime_US/Canada)', value: 'Canada/Mountain' },
  { label: 'GMT-06:00 (CentralTime_US/Canada)', value: 'Canada/Central' },
  { label: 'GMT-05:00 (EasternTime_US/Canada)', value: 'US/Eastern' },
  { label: 'GMT-04:00 (Atlantic Time)', value: 'Canada/Atlantic' },
  { label: 'GMT-03:30 (Newfoundland)', value: 'Canada/Newfoundland' },
  { label: 'GMT-03:00 (Brasilia)', value: 'America/Fortaleza' },
  { label: 'GMT-02:00 (Mid-Atlantic)', value: 'America/Noronha' },
  { label: 'GMT-01:00 (Azores)', value: 'Atlantic/Azores' },
  { label: 'GMT+00:00 (GreenwichMeanTime_London)', value: 'Europe/London' },
  { label: 'GMT+01:00 (Amsterdam, Berlin, Vienna)', value: 'Europe/Amsterdam' },
  { label: 'GMT+02:00 (Athens, Cairo)', value: 'Europe/Athens' },
  { label: 'GMT+03:00 (Moscow, Baghdad)', value: 'Europe/Moscow' },
  { label: 'GMT+03:30 (Tehran)', value: 'Asia/Tehran' },
  { label: 'GMT+04:00 (Baku, Muscat)', value: 'Asia/Muscat' },
  { label: 'GMT+04:30 (Kabul)', value: 'Asia/Kabul' },
  { label: 'GMT+05:00 (Ashgabat)', value: 'Asia/Ashgabat' },
  { label: 'GMT+05:30 (NewDelhi, Mumbai, Colombo, Kolkata)', value: 'Asia/Kolkata' },
  { label: 'GMT+05:45 (Katmandu)', value: 'Asia/Kathmandu' },
  { label: 'GMT+06:00 (Astana, Dhaka)', value: 'Asia/Dhaka' },
  { label: 'GMT+06:30 (Yangon)', value: 'Asia/Yangon' },
  { label: 'GMT+07:00 (Bangkok, Hanoi, Jakarta)', value: 'Asia/Bangkok' },
  {
    label: 'GMT+08:00 (Beijing, Dalian, Singapore, Taiwan)',
    value: 'Hongkong',
  },
  { label: 'GMT+09:00 (Seoul)', value: 'Asia/Seoul' },
  { label: 'GMT+09:00 (Tokyo, Fukuoka)', value: 'Asia/Tokyo' },
  { label: 'GMT+09:30 (Darwin, Adelaide)', value: 'Australia/Darwin' },
  { label: 'GMT+10:00 (Guam, Canberra, Sydney)', value: 'Australia/Canberra' },
  { label: 'GMT+10:30 (LordHoweIsland)', value: 'Australia/Lord_Howe' },
  { label: 'GMT+11:00 (NewCaledonia)', value: 'Pacific/Noumea' },
  { label: 'GMT+11:30 (NorfolkIsland)', value: 'Pacific/Norfolk' },
  { label: 'GMT+12:00 (Auckland, Fiji)', value: 'Pacific/Auckland' },
];
export enum FAVORITE_TYPE {
  FOLDER = 0,
  CHANNEL = 1,
  MEMBER = 2,
}

export const FOLLOWING_TYPE = {
  PRIVATE: 3,
  DIRECT: 4,
  MEMBER: 5,
};

export const DRAGGABLE_ITEM_TYPE = {
  FAVORITE_CHANNEL: 'FAVORITE_CHANNEL',
  FAVORITE_FOLDER: 'FAVORITE_FOLDER',
};

export const PANEL_TYPE = {
  LOG: 'log',
  NOTICE: 'notice',
  FILE: 'file',
  STAR: 'start',
  MENTION: 'mention',
  LINK: 'link',
  NONE: 'none',
  CHANNEL_INFO: 'channelInfo',
  SIDE_APP: 'sideApp',
} as const;
export type PANEL_TYPE = ValueOf<typeof PANEL_TYPE>;

export const GNB_TABS = {
  ORGANIZATION_CHART: 'ORGANIZATION_CHART',
  FAVORITE: 'chat',
  RECENT: 'recent',
} as const;
export type GNB_TABS = ValueOf<typeof GNB_TABS>;

export const NOTIFICATION = {
  ON: 'loud',
  OFF: 'never',
} as const;
export type NOTIFICATION = ValueOf<typeof NOTIFICATION>;

export const ICON_BG_LIST = [
  '#EBAEE7',
  '#B999E7',
  '#999CE5',
  '#98B8F0',
  '#86CCF0',
  '#8BD6BB',
  '#C3D28D',
  '#F2E078',
  '#F2C76E',
  '#F2A772',
  '#F48B8B',
  '#B3BDCF',
];

export const TableNames = {
  DraftLogs: 'DRAFT_LOGS',
  FavoriteFolderOpened: 'FAVORITE_FOLDER_OPENED',
  Settings: 'SETTINGS',
  SideAppReadURL: 'SIDE_APP_READ_URL',
} as const;
export type TableNames = ValueOf<typeof TableNames>;

export const ALL_API_SIZE = 1000000;
export const MAX_IMAGE_SIZE = 1_048_5760; // 10MB
export const MAX_TENANT_FILE_UPLOAD_SIZE_LITE = 104_857_600; // 100MB
export const MAX_PREVIEW_ABLE_IMAGE_SIZE = 15_728_640; // 15MB

export const NOTI_PERMISSION = {
  GRANTED: 'granted',
  DENIED: 'denied',
};

export const PopperType = {
  Profile: 'profile',
  EditorPopper: 'editorPopper',
  UnreadLogMembers: 'unreadLogMembers',
  CoachMark: 'coachMark',
  StickerEmoticon: 'stickerEmoticon',
  LogMenu: 'logMenu',
} as const;
export type PopperType = ValueOf<typeof PopperType>;

export const NEW_LINE_MANNER = {
  ENTER: 'ENTER',
  SHIFT_ENTER: 'SHIFT+ENTER',
};
export type NEW_LINE_MANNER = ValueOf<typeof NEW_LINE_MANNER>;

export const COMMAND_ACCESS_TYPE = {
  HIDE: 0,
  SHOW: 1,
};

export const ADDABLE_APP_LIMIT_COUNT = 5;
export const ADDABLE_APP_LIMIT_COUNT_TENANT = {
  LITE: 5,
  BASIC: 20,
};

export const ADDABLE_COMMAND_LIMIT_COUNT = 5;

export const CHANNEL_SETTING_TAB = {
  MEMBER: 'MEMBER',
  SETTING: 'SETTING',
};

export const SHORTCUT_KEY = {
  SEARCH_INPUT_LEFT: 'SEARCH_INPUT_LEFT',
  SEARCH_INPUT_RIGHT: 'SEARCH_INPUT_RIGHT',
  SEARCH_INPUT_UP: 'SEARCH_INPUT_UP',
  SEARCH_INPUT_DOWN: 'SEARCH_INPUT_DOWN',
  SEARCH_INPUT_ENTER: 'SEARCH_INPUT_ENTER',
  GLOBAL_FUNC_K: 'GLOBAL_FUNC_K',
};

export const GLOBAL_SETTING_TABS = {
  GENERAL: 'GENERAL',
  NOTIFICATION: 'NOTIFICATION',
};

export const NOTIFICATION_RANGE = {
  ALL: 'ALL',
  SENDER: 'SENDER',
  NONE: 'NONE',
} as const;
export type NOTIFICATION_RANGE = ValueOf<typeof NOTIFICATION_RANGE>;

export const IMAGE_EDITOR_MENUS = {
  EDIT: {
    MOVE: 'MOVE',
    TEXT: 'TEXT',
    LINE: 'LINE',
  },
  TRANSFORM: {
    CROP: 'CROP',
    ROTATE: 'ROTATE',
  },
  FLOW: {
    RESET: 'RESET',
    REDO: 'REDO',
    UNDO: 'UNDO',
  },
};

export enum ChannelMemberRole {
  Creator = 'creator',
  Member = 'member',
}

export const MAX_MESSAGE_LEN = 12_000;

export const MAX_MESSAGE_LEN_LITE = 500;

export const ALERT_TYPE = {
  SUCCESS: 'success',
  INFO: 'info',
  ERROR: 'error',
  WARNING: 'warning',
};

export const KEYS = {
  LEFT: 'left',
  RIGHT: 'right',
  UP: 'up',
  DOWN: 'down',
  ENTER: 'enter',
  COMMAND: 'command',
  CTRL: 'ctrl',
  ESC: 'esc',
  ALT: 'alt',
} as const;
export type KEYS = ValueOf<typeof KEYS>;

export const CHANNEL_HEIGHT = 48;

export const HINT_HEIGHT = 32;

export const Unit = undefined;

// export const DOORAY_ID_PROVIDER_ID = '5';

export const LOG_CHAIN_FLAG = {
  CHAIN: 'CHAIN',
  HEAD: 'HEAD',
  TAIL: 'TAIL',
};

export const STICKER_PAGE_COUNT = 7;

export const CHUNK_TYPE = {
  EMOJI: 'EMOJI',
  TEXT: 'TEXT',
  CODE_BLOCK: 'CODE_BLOCK',
  INLINE_CODE: 'INLINE_CODE',
  MENTION: 'MENTION',
  URL: 'URL',
  MARKDOWN_LINK: 'MARKDOWN_LINK',
} as const;

export type CHUNK_TYPE = ValueOf<typeof CHUNK_TYPE>;

export const test = 'test';

export enum CoachMarkShape {
  Rect = 'rect',
  Circle = 'circle',
  ClickableCircle = 'clickable-circle',
}

export const Placement = {
  Top: 'top',
  TopEnd: 'top-end',
  TopStart: 'top-start',
  Bottom: 'bottom',
  BottomEnd: 'bottom-end',
  BottomStart: 'bottom-start',
  Left: 'left',
  LeftStart: 'left-start',
  Right: 'right',
  RightStart: 'right-start',
} as const;
export type Placement = ValueOf<typeof Placement>;

export const CoachMarkType = {
  Main: 'main',
  InviteChannel: 'inviteChannel',
  StatusIcon: 'statusIcon',
  MakeThread: 'makeThread',
  CloseThread: 'closeThread',
  ExportTaskWithAI: 'exportTaskWithAI',
} as const;
export type CoachMarkType = ValueOf<typeof CoachMarkType>;

export const CoachMarkName = {
  CreateChannel: 'createChannel',
  SearchChannel: 'searchChannel',
  Invite: 'invite',
  Collection: 'collection',
  InviteChannel: 'inviteChannel',
  UserMenuStatusIcon: 'userMenuStatusIcon',
  MakeThread: 'makeThread',
  CloseThread: 'closeThread',
  ExportTaskWithAI: 'exportTaskWithAI',
} as const;
export type CoachMarkName = ValueOf<typeof CoachMarkName>;

export const COACH_MARK_THEME = {
  DEFAULT: 'default',
  CLOSE_BTN: 'closeBtn',
} as const;
export type COACH_MARK_THEME = ValueOf<typeof COACH_MARK_THEME>;

export enum PROFILE_TYPE {
  MEMBER = 'MEMBER',
  APP = 'APP',
}

export const DEPARTMENT_MEMBERS_SIZE = 30;

export const READMEMBER_SHOW_LIMIT_CAPACITY = 100;

export const INVITE_CAPACITY_LIMIT = 100;

export const INVITE_CAPACITY_LIMIT_LITE = 30;

export const LOG_SEARCH_KEYWORD_MAX_LEN = 50;

export const CHANNEL_MEMBER_SEARCH_KEYWORD_MAX_LEN = 30;

export const INCOMING_HOOK_LIMIT_LITE = 50;
export const INCOMING_HOOK_LIMIT_BASIC = 100;

export enum SUBSCRIPTION_PLAN {
  FREETRIAL = 'freeTrial',
  LITE = 'lite',
  BASIC = 'basic',
  BUSINESS = 'business',
}

export enum SUBSCRIPTION_CODE {
  MESSENGER = 'messenger',
  MAIL = 'mail',
  PROJECT = 'project',
  PROJECT_MAIL = 'projectMail',
  WORKFLOW = 'workflow',
  MAIL_WORKFLOW = 'mailWorkflow',
  WORKFLOW_PROJECT = 'workflowProject',
  MAIL_WORKFLOW_PROJECT = 'mailWorkflowProject',
}

export enum SERVICE {
  PROJECT = 'project',
  MAIL = 'mail',
  CALENDAR = 'calendar',
  WIKI = 'wiki',
  DRIVE = 'drive',
  CONTACTS = 'contacts',
  WORKFLOW = 'workflow',
  MESSENGER = 'messenger',
}

export enum Page {
  PopupChannel = 'PopupChannel',
  Messenger = 'Messenger',
  Integration = 'Integration',
  PopupImage = 'PopupImage',
  Orgs = 'Orgs',
  Error400 = 'Error400',
  Error500 = 'Error500',
  Unauthorized = 'Unauthorized',
  UnauthorizedIP = 'UnauthorizedIP',
  NotFound = 'NotFound',
  ShareChannel = 'ShareChannel',
}

export const HTTP_CLIENT_HEADER = 'X-Client-Request-Id';
export const HTTP_CLIENT_IP = 'x-client-ip';

export enum AXIOS_ERROR {
  ECONNABORTED = 'ECONNABORTED',
}

export enum AXIOS_ERROR_MESSAGE {
  REQUEST_ABORTED = 'Request aborted',
}

export enum HTTP_STATUS {
  BAD_GATEWAY = 502,
  FORBIDDEN = 403,
  GATEWAY_TIMEOUT = 504,
  HTTP_VERSION_NOT_SUPPORTED = 505,
  INSUFFICIENT_STORAGE = 507,
  INTERNAL_SERVER_ERROR = 500,
  MOVED_PERMANENTLY = 301,
  MOVED_TEMPORARILY = 302,
  NOT_FOUND = 404,
  NOT_IMPLEMENTED = 501,
  SERVICE_UNAVAILABLE = 503,
  UNAUTHORIZED = 401,
  UNKNOWN = -1,
  TIMEOUT = 408,
  TOO_MANY_REDIRECT = 429,
}

export enum SERVER_ERROR {
  SERVICE_GENERAL_ERROR = -100_000,
  SERVICE_API_ERROR = -100_100,
  SERVICE_API_GENERAL_ERROR = -100_101,
  SERVICE_ACL_ERROR = -100_116,
  AUTH_FORBIDDEN_ACL_IP_ERROR = -400_202,
  AUTH_FORBIDDEN_ACL_SERVICE_ERROR = -400_201,
  AUTH_FORBIDDEN_ERROR = -500_200,
  AUTH_FORBIDDEN_FILE_ACL_IP_ERROR = -400_204,
  AUTH_FORBIDDEN_FILE_ACL_SERVICE_ERROR = -400_203,
  AUTH_GENERAL_ERROR = -500_000,
  AUTH_UNAUTHORIZED_ERROR = -500_100,
  CHANNEL_ADMIN_CANNOT_LEAVE_ERROR = -300_215,
  CHANNEL_ALREADY_EXISTS_ERROR = -300_101,
  CHANNEL_ALREADY_JOINED_ERROR = -300_103,
  CHANNEL_TITLE_LENGTH_TOO_LONG_ERROR = -300_114,
  CHANNEL_DESCRIPTION_LENGTH_TOO_LONG_ERROR = -300_116,
  CHANNEL_ALREADY_SAME_JOINED_MEMBERS_EXIST_ERROR = -300_117,
  CHANNEL_ARCHIVE_FAIL_ERROR = -300_110,
  CHANNEL_CANNOT_DELETE_BOT_CHANNEL_ERROR = -300_107,
  CHANNEL_CAPACITY_IS_FULL_ERROR = -300_109,
  CHANNEL_CREATE_DIRECT_INVALID_MEMBER_IDS_ERROR = -300_113,
  CHANNEL_CREATE_INVALID_CAPACITY_ERROR = -300_108,
  CHANNEL_DB_ERROR = -300_105,
  CHANNEL_DIRECT_CANNOT_CHANGE_TITLE_ERROR = -300_111,
  CHANNEL_GENERAL_ERROR = -300_100,
  CHANNEL_HAS_JOINED_MEMBER_ERROR = -300_106,
  CHANNEL_INVALID_FLAG_ERROR = -300_119,
  CHANNEL_LOG_ALREADY_EXIST = -300_307,
  CHANNEL_LOG_ATTACHMENT_SIZE_IS_TOO_BIG_ERROR = -300_305,
  CHANNEL_LOG_BAD_SEQUENCE_ERROR = -300_301,
  CHANNEL_LOG_CANNOT_SEND_ERROR = -300_302,
  CHANNEL_LOG_CRYPTO_ERROR = -300_303,
  CHANNEL_LOG_EXPIRED_DELETE_TIME_ERROR = -300_313,
  CHANNEL_LOG_EXPIRED_MODIFY_TIME_ERROR = -300_314,
  CHANNEL_LOG_GENERAL_ERROR = -300_300,
  CHANNEL_LOG_SEND_MESSAGE_TOO_LONG_ERROR = -300_304,
  CHANNEL_MEMBER_ALREADY_GRANTED_ERROR = -300_203,
  CHANNEL_MEMBER_ALREADY_JOINED_ERROR = -300_204,
  CHANNEL_MEMBER_BELONG_TO_OTHER_ORG_ERROR = -300_212,
  CHANNEL_MEMBER_CANNOT_SET_PREFERENCE_ERROR = -300_208,
  CHANNEL_MEMBER_DB_ERROR = -300_201,
  CHANNEL_MEMBER_GENERAL_ERROR = -300_200,
  CHANNEL_MEMBER_INVALID_CHANNEL_PERMISSION_ERROR = -300_202,
  CHANNEL_MEMBER_IS_INVALID_ERROR = -300_211,
  CHANNEL_MEMBER_IS_NOT_DIRECT_MEMBER_ERROR = -300_210,
  CHANNEL_MEMBER_NOT_EXISTS_ERROR = -300_207,
  CHANNEL_MEMBER_NOT_GRANTED_ERROR = -300_205,
  CHANNEL_MEMBER_PREFERENCE_IS_NULL_ERROR = -300_209,
  CHANNEL_MEMBER_READ_SEQ_BIGGER_THAN_CHANNEL_SEQ_ERROR = -300_206,
  CHANNEL_NOT_EXISTS_ERROR = -300_102,
  CHANNEL_NOT_JOINED_MEMBER_ERROR = -300_104,
  CHANNEL_TITLE_ALREADY_USED_ERROR = -300_112,
  INTEGRATION_APP_NOT_EXIST_ERROR = -300_501,
  INTEGRATION_APP_NUMBER_OVER_LIMIT_ERROR = -300_509,
  INTEGRATION_COMMAND_NOT_REGISTERED_IN_CHANNEL_ERROR = -300_505,
  INTEGRATION_COMMAND_NUMBER_OVER_LIMIT_ERROR = -300_508,
  INTEGRATION_APP_NAME_IS_TOO_LONG = -300_512,
  INTEGRATION_APP_DESCRIPTION_IS_TOO_LONG = -300_513,
  INTEGRATION_COMMAND_NAME_IS_TOO_LONG = -300_514,
  INTEGRATION_COMMAND_DESCRIPTION_IS_TOO_LONG = -300_515,
  INTEGRATION_APP_NUMBER_OVER_TENANT_LIMIT_ERROR = -300_516,
  MEMBER_ALREADY_EXISTS_ERROR = -200_102,
  MEMBER_CHANNEL_FAVORITE_FOLDER_TITLE_ALREADY_EXISTS_ERROR = -200_110,
  MEMBER_GENERAL_ERROR = -200_000,
  MEMBER_INSERT_FAIL_ERROR = -200_104,
  MEMBER_NOT_EXISTS_ERROR = -200_101,
  MEMBER_PREFERENCE_IS_NULL_ERROR = -200_103,
  SERVER_DB_ERROR = -400_100,
  SERVER_FILE_DOWNLOAD_FORBIDDEN_EXTENSIONS_ERROR = -400_411,
  SERVER_FILE_OVER_LIMIT_OF_TOTAL_SIZE_PER_TENANT_ERROR = -400_414,
  SERVER_FILE_EXPIRED_ERROR = -400_407,
  SERVER_FILE_SIZE_IS_TOO_BIG_ERROR = -400_406,
  SERVER_FILE_TRANSFER_FILE_IS_NULL_ERROR = -400_404,
  SERVER_FILE_TRANSFER_GENERAL_ERROR = -400_400,
  SERVER_FILE_TRANSFER_INVALID_HEADER_ERROR = -400_405,
  SERVER_FILE_TRANSFER_THUMBNAIL_FAIL_ERROR = -400_402,
  SERVER_FILE_TRANSFER_THUMBNAIL_UPLOAD_FAIL_ERROR = -400_403,
  SERVER_FILE_TRANSFER_UPLOAD_FAIL_ERROR = -400_401,
  SERVER_FILE_UPLOAD_FORBIDDEN_EXTENSIONS_ERROR = -400_410,
  SERVER_GENERAL_ERROR = -400_000,
  SERVER_SAME_SESSION_KEY = -400_800,
  SERVER_SHARD_IS_NOT_READY = -400_600,
  SERVER_TASK_TRACKER_ERROR = -400_300,
  SERVER_TASK_TRACKER_TIMEOUT_ERROR = -400_302,
  SERVER_TASK_TRACKER_UNAUTHORIZED_SESSION_ERROR = -400_301,
  SERVICE_API_CANNOT_SUPPORT_ERROR = -100_107,
  SERVICE_API_EMPTY_BODY_ERROR = -100_103,
  SERVICE_API_INVALID_APP_KEY_ERROR = -100_108,
  SERVICE_API_INVALID_REQUEST_BODY_ERROR = -100_106,
  SERVICE_API_NOT_EXIST_QUERY_PARAM_ERROR = -100_104,
  SERVICE_API_NOT_FOUND_ERROR = -100_102,
  SERVICE_API_TIMEOUT_ERROR = -100_105,
  SERVICE_API_UNAUTHORIZED_APP_KEY_ERROR = -100_109,
  SERVICE_API_UNAUTHORIZED_IP_ERROR = -100_110,
  TRAFFIC_ERROR = -900_000,
  WEBSOCKET_INVALID_REQUEST_ERROR = -600_000,
  SERVER_SIDE_APP_UNAVAILABLE_ERROR = -700_403,
  FILE_TENANT_USAGE_LIMIT_OVER_ERROR = -600_200,
  FILE_MEMBER_USAGE_LIMIT_OVER_ERROR = -600_100,
  INVALID_AI_LICENSE_ERROR = -32_400_044,
}

export enum AbsenceType {
  HIDDEN = 'hidden',
  BUSINESS_TRIP = 'business_trip',
  EDUCATION = 'education',
  SICK_LEAVE = 'sick_leave',
  VACATION = 'vacation',
  TEMPORARY_REST = 'temporary_rest',
  ETC = 'etc',
}

export enum VacationFlag {
  REPLY_FROM_INTERNAL_MAIL = 'reply_from_internal_mail',
  REPLY_FROM_EXTERNAL_MAIL = 'reply_from_external_mail',
}

export const vacationDateFormat = 'YYYY-MM-DDTHH:mm:ssZ';

export enum LogRowType {
  DayDivider = 'dayDivider',
  LoadingPrev = 'loadingPrev',
  LoadingNext = 'loadingNext',
  LoadingLogs = 'loadingLogs',
  NewLogSign = 'newLogSign',
  NotInWork = 'notInWork',
}

export enum CallerMenu {
  IpPhone = 'ipPhone',
  CellPhone = 'cellPhone',
}

export enum FavoriteFolderMenu {
  Title = 'title',
  Remove = 'remove',
}

export enum ChannelSettingMemberMenu {
  Chat = 'chat',
  Profile = 'profile',
  Leave = 'leave',
  Kick = 'kick',
  AddAdmin = 'addAdmin',
  DeleteAdmin = 'deleteAdmin',
}

export enum UserMenu {
  Active = 'ACTIVE',
  Busy = 'BUSY',
  Away = 'AWAY',
  Profile = 'PROFILE',
  GlobalSetting = 'GLOBAL_SETTING',
  ManageMembers = 'MANAGE_MEMBERS',
  InviteMembers = 'INVITE_MEMBERS',
  CommandSetting = 'COMMAND_SETTING',
  SlashCommand = 'SLASH_COMMAND',
  ManageHiddenChannel = 'ManageHiddenChannel',
  Release = 'RELEASE',
  Download = 'DOWNLOAD',
  Inquire = 'INQUIRE',
  Logout = 'LOGOUT',
}

export const CreateChannelMenu = {
  Direct: 'direct',
  Private: 'private',
} as const;
export type CreateChannelMenu = ValueOf<typeof CreateChannelMenu>;

export enum NewLineMenu {
  ShiftEnter = 'shiftEnter',
  Enter = 'enter',
}

export const LOG_MENU = {
  NOTICE: 'notice',
  EDIT: 'edit',
  DELETE: 'delete',
  FORWARD: 'forward',
  REPLY: 'reply',
  REACTION: 'reaction',
  THREAD: 'thread',
  OK: 'ok',
  HEARTS: 'hearts',
  THUMB_UP: 'thumbUp',
  HEAVY_CHECK_MARK: 'heavyCheckMark',
} as const;
export type LOG_MENU = ValueOf<typeof LOG_MENU>;

export const CHANNEL_MENU = {
  POPUP: 'popup',
  FAVORITE_ON: 'favoriteOn',
  FAVORITE_OFF: 'favoriteOff',
  SETTING: 'setting',
  PROFILE: 'profile',
  NOTIFICATION_OFF: 'notificationOff',
  NOTIFICATION_ON: 'notificationOn',
  DISPLAY_OFF: 'displayOff',
  DISPLAY_ON: 'displayOn',
  LEAVE: 'leave',
} as const;
export type CHANNEL_MENU = ValueOf<typeof CHANNEL_MENU>;

export const NOTICE_MENU = {
  DELETE: 'delete',
  SHOW_LIST: 'showList',
} as const;
export type NOTICE_MENU = ValueOf<typeof NOTICE_MENU>;

export const ALERT_METERING_TYPE = {
  ALMOST_OVER: 'almostOver',
  IS_OVER: 'isOver',
} as const;
export type ALERT_METERING_TYPE = ValueOf<typeof ALERT_METERING_TYPE>;

export enum Emoticon {
  Sticker = 'sticker',
  Emoticon = 'emoticon',
}

export const EmoticonColCount = {
  [Emoticon.Sticker]: 3,
  [Emoticon.Emoticon]: 11,
};

export const MAX_FREE_MEMBER_COUNT = 25;

export enum LogFetchDirection {
  Both = 'both',
  Next = 'next',
  Prev = 'prev',
}

export enum AttachmentActionType {
  Select = 'select',
  Button = 'button',
}

export enum IncomingHookTabType {
  InServices = 'inServices',
  AddableServices = 'addableServices',
}

export enum IncomingHookServiceType {
  Incoming = 'Incoming',
  Figma = 'Figma',
  Zeplin = 'Zeplin',
  Jenkins = 'Jenkins',
  GitHub = 'GitHub',
  GitLab = 'GitLab',
  NewRelic = 'NewRelic',
  JIRA = 'JIRA',
  Bitbucket = 'Bitbucket',
  IFTTT = 'IFTTT',
  Grafana = 'Grafana',
  Sonarqube = 'Sonarqube',
}

export const BOTTOM_LOG_ID = 'logs-bottom';
export type BOTTOM_LOG_ID = 'logs-bottom';
export const EMPTY_LOG_ID = 'logs-empty';
export type EMPTY_LOG_ID = 'logs-empty';
export const UNREAD_LOG_ID = 'logs-unread';
export type UNREAD_LOG_ID = 'logs-unread';

export enum CommandType {
  Default = 0,
  Normal = 1,
}

export enum ChannelFlag {
  System = 'system',
  Normal = 'normal',
  Deleted = 'deleted',
  Archived = 'archived',
  // client 에서 만든 채널
  Custom = 'custom',
}

export const MANAGE_HIDDEN_CHANNEL_TAB = {
  Hidden: 'Hidden',
  Archived: 'Archived',
} as const;
export type MANAGE_HIDDEN_CHANNEL_TAB = ValueOf<typeof MANAGE_HIDDEN_CHANNEL_TAB>;

export enum EffectiveFeature {
  personalPage = 'personalPage',
  webOffice = 'webOffice',
  aliasEmailAddressLogin = 'aliasEmailAddressLogin',
  changePersonalExternalEmailAddress = 'changePersonalExternalEmailAddress',
  notificationExternalEmail = 'notificationExternalEmail',
  fromAlias = 'fromAlias',
}

export enum ApprovalEffectiveFeature {
  inviteMember = 'inviteMember',
  inviteGuest = 'inviteGuest',
  addSubMember = 'addSubMember',
  createProject = 'createProject',
  addMemberCapacity = 'addMemberCapacity',
}

export enum AnimationEffect {
  CherryBlossom = 'cherryBlossom',
}

export const CherryBlossomKeywords = [
  '벚꽃',
  '꽃놀이',
  '꽃구경',
  '축제',
  'cherry blossom',
  'festival',
  'love',
  '桜',
  '花',
  'お花見',
  '花見',
  '春の花',
  '花見',
  '愛',
  '祭り',
  'さくら',
];

export const CherryBlossomRegex = new RegExp(CherryBlossomKeywords.join('|'), 'i');

// QA 테스트
export const SHOW_QA_HOST = [
  'nhnent.dev.dooray.com',
  'nhnent.beta.dooray.com',
  'podo.dev.dooray.com',
  'gb7.beta.gov-dooray.com',
  'mulidp.beta.gov-dooray.com',
  'mulsso.beta.gov-dooray.com',
  'muldooray.beta.gov-dooray.com',
];

export enum IpPhoneStatus {
  UNKNOWN = 'UNKNOWN', // IP 전화기가 아니거나 상태 알 수 없음
  IDLE = 'IDLE', // 통화 중 아님
  ACTIVE = 'ACTIVE', // 통화 중
  ALERTING = 'ALERTING', // 통화 수신음 나오는 중
}

export const COPY_RIGHT = '© NHN Corp. All rights reserved.';

export const EDITOR_ID = {
  MAIN: 'js-main-editor',
  LOG: 'js-log-editor',
  THREAD_MAIN: 'js-thread-main-editor',
  THREAD_LOG: 'js-thread-log-editor',
};
export type EDITOR_ID = ValueOf<typeof EDITOR_ID>;

export const SEARCH_LOG_TYPE = {
  ALL: 'messageThread',
  THREAD: 'thread',
  MESSAGE: 'message',
} as const;
export type SEARCH_LOG_TYPE = ValueOf<typeof SEARCH_LOG_TYPE>;

export const THREAD_MENU = {
  FOLLOW: 'follow',
  UNFOLLOW: 'unfollow',
  EXPORT_TASK: 'exportTask',
  EXPORT_TASK_WITH_AI: 'exportTaskWithAI',
};
export type THREAD_MENU = ValueOf<typeof THREAD_MENU>;

export const MAIN_THREAD_CHANNEL_ID = '1000000000000000001';

export const EXPORT_TASK_WITH_AI_COACH_MARK_KEY = 'HIDDEN_EXPORT_TASK_WITH_AI_COACH_MARK';

export const SEARCH_CHANNEL_TYPE = {
  MESSAGE: 'MESSAGE',
  THREAD: 'THREAD',
};
export type SEARCH_CHANNEL_TYPE = ValueOf<typeof SEARCH_CHANNEL_TYPE>;
